import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchCourseData = createAsyncThunk(
  "api/course",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("other");
      const url = `${EndPoints.PRISM_GET_COURSES}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const err = await response.text();
        return rejectWithValue(err);
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const courseSlice = createSlice({
  name: "course",
  initialState: {
    coursesdata: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetCourseState: (state) => {
      state.coursesdata = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCourseData.fulfilled, (state, action) => {
        state.loading = false;
        state.coursesdata = action.payload;
      })
      .addCase(fetchCourseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetCourseState } = courseSlice.actions;
export default courseSlice.reducer;
